// @flow

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from '../../../commons/modal/modal';
import styles from './depositSlipModal.scss';
import InputField from '../../../commons/formElements/inputField/inputField';
import { cancelDepositSlipDetailAction } from './depositSlipDashboardRedux/depositSlipDashboardActionCreator';
import Loader from '../../../commons/loader/loader';

type Props = {
  showModal: boolean,
  isCancellationLoading: boolean,
  closeModal: Function,
  title: string,
  depositSlipId: number,
  cancelDepositSlipDetail: funtion
};

type State = {};

class DepositSlipCancellationModal extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      reason: ''
    };
  }

  getValidations() {
    const { reason } = this.state;
    if (!reason) {
      return 'Please enter reason';
    }
    return null;
  }

  clearState() {
    this.setState({
      reason: ''
    });
  }

  closeModal() {
    this.clearState();
    this.props.closeModal();
  }

  handleReasonChange(e) {
    this.setState({
      reason: e.target.value,
      errorMessage: ''
    });
  }

  handleSubmitClick() {
    const message = this.getValidations();
    const { cancelDepositSlipDetail, depositSlipId } = this.props;
    const { reason } = this.state;
    this.setState({
      errorMessage: message
    });
    if (!message) {
      cancelDepositSlipDetail({
        id: depositSlipId,
        reason
      });
      this.clearState();
    }
  }

  render() {
    const { isCancellationLoading, showModal, title } = this.props;
    const { errorMessage, reason } = this.state;
    return (
      <Modal
        showModal={showModal}
        title={title}
        closeModal={() => this.closeModal()}
      >
        {isCancellationLoading ? (
          <div className="loader-wrapper">
            <Loader message="Please wait..." />
          </div>
        ) : null}
        <div className={`${styles.modalWrapper}`}>
          <div className={styles.modalTitle}>
            Are you sure you want to cancel?
          </div>
          <div className="flex-100 l-row">
            <div className="flex-50 l-col j-start">
              <span className={styles.textStyle}>Reason</span>
            </div>
            <div className="flex-50 l-col j-start">
              <InputField
                type="text"
                onInput={e => this.handleReasonChange(e)}
                onChange={_ => _}
                value={reason}
              />
            </div>
          </div>
          {errorMessage ? (
            <div className="l-row">
              <span className={styles.errorMessage}>{errorMessage}</span>
            </div>
          ) : null}
          <div className="flex-100 l-row j-end a-center">
            <div
              className="cancel-btn-wrapper l-row j-center a-center"
              onClick={() => this.closeModal()}
            >
              IGNORE
            </div>
            <div
              className="submit-btn-wrapper l-row j-center a-center"
              onClick={() => this.handleSubmitClick()}
            >
              SUBMIT
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  cancelDepositSlipDetail: bindActionCreators(
    cancelDepositSlipDetailAction,
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DepositSlipCancellationModal);
